module.exports = __webpack_public_path__ + "img/trd-logo-light.d62557ec.svg";